<template>
  <div style="min-height: 100vh; display: flex">
    <v-row align="center" justify="center" no-gutters>
      <v-card flat width="90%" max-width="400px" class="pa-4 elevation-8">
        <v-card-title>Фортуна-Логистика</v-card-title>
        <v-divider />

        <!-- УБРАН блок с v-alert для ошибок -->

        <v-form>
          <v-col cols="12 px-0">
            <v-text-field v-model="login" type="text" label="Пользователь" :placeholder="!autofilled ? ' ' : ''"
              :error-messages="loginErrors" required autocomplete="username" @input="$v.login.$touch()"
              @blur="$v.login.$touch()">
              <template v-slot:prepend>
                <v-icon>mdi-account-outline</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12 px-0">
            <v-text-field v-model="password" label="Пароль" :placeholder="!autofilled ? ' ' : ''"
              :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'" :type="passwordVisible ? 'text' : 'password'"
              :error-messages="passwordErrors" autocomplete="password" @input="$v.password.$touch()"
              @blur="$v.password.$touch()" @click:append="passwordVisible = !passwordVisible">
              <template v-slot:prepend>
                <v-icon>mdi-lock-outline</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-card-actions class="px-0">
            <v-spacer />
            <v-btn class="px-8" color="primary" :loading="submiting" @click.prevent="okClick">
              Войти
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-row>
  </div>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import router from '../router'

export default {
  data: () => ({
    login: '',
    password: '',
    passwordVisible: false,
    submiting: false,
    autofilled: false,
    from: null
    // УБРАНО поле errorMessage
  }),

  computed: {
    loginErrors() {
      const errors = []
      if (!this.$v.login.$dirty) return errors
      !this.$v.login.maxLength && errors.push(`Не более ${this.$v.login.$params.maxLength.max} символов, пожалуйста`)
      !this.$v.login.minLength && errors.push('Слишком короткое имя пользователя')
      !this.$v.login.required && errors.push('Введите имя пользователя')
      return errors
    },

    passwordErrors() {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.maxLength &&
        errors.push(`Не более ${this.$v.password.$params.maxLength.max} символов, пожалуйста`)
      !this.$v.password.required && errors.push('Введите пароль')
      return errors
    }
  },

  watch: {
    password() {
      this.autofilled = true
    },
    login() {
      this.autofilled = true
    }
  },

  validations: {
    login: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(100)
    },
    password: {
      required,
      maxLength: maxLength(20)
    }
  },

  created() {
    const from = this.$route.query.from
    if (from) this.from = from
    this.$store.dispatch('auth/logout')
  },

  methods: {
    async okClick() {
    // Валидация
    if (this.$v.$invalid) {
      this.$v.$touch();

      if (!this.$v.login.required) {
        this.$notify('error', 'Введите имя пользователя', 5000);
        return;
      } else if (!this.$v.login.minLength) {
        this.$notify('error', 'Слишком короткое имя пользователя', 5000);
        return;
      } else if (!this.$v.password.required) {
        this.$notify('error', 'Введите пароль', 5000);
        return;
      }
      return;
    }

    this.submiting = true;

    try {
      const response = await this.$store.dispatch('auth/login', {
        login: this.login,
        password: this.password,
      });

      // Проверяем, что ответ вообще есть
      if (!response) {
        throw new Error('Сервер вернул пустой ответ');
      }

      // Сохраняем userId если есть
      if (response?.userId) {
        localStorage.setItem('userId', response.userId);
      }
      
      // Проверяем, требуется ли код подтверждения
      if (response.requiresCode === true) {
        // Отправляем на ввод кода
        this.$notify(
          'info',
          'На Ваш адрес электронной почты отправлено письмо с кодом подтверждения',
          10000
        );
        router.push('/login/code');
        return; // Выходим, дальше не идем
      }

      // Если код НЕ требуется, но токена нет - ЭТО ОШИБКА!
      if (!response?.token) {
        this.$notify('error', 'Сервер не вернул токен авторизации', 5000);
        return;
      }

      // Сохраняем токен
      localStorage.setItem('token', response.token);
      this.$store.state.auth.token = response.token;

      // Загружаем данные пользователя
      try {
        await this.$store.dispatch('auth/setUser');
        this.$router.push('/carQueue');
      } catch (userError) {
        this.$notify('error', 'Ошибка при загрузке данных пользователя', 5000);
        // Разлогиниваем, так как пользователь не загрузился
        this.$store.dispatch('auth/logout');
      }

    } catch (error) {
      // Обработка HTTP ошибок
      if (error.response) {
        const status = error.response.status;
        const message = error.response.data?.message || error.response.data?.error || '';

        switch (status) {
          case 400:
            this.$notify('error', `Неверный запрос: ${message}`, 5000);
            break;
          case 401:
            this.$notify('error', 'Неверный логин или пароль', 5000);
            break;
          case 403:
            this.$notify('error', 'Доступ запрещен. Обратитесь к администратору', 5000);
            break;
          case 404:
            this.$notify('error', 'Пользователь не найден', 5000);
            break;
          case 429:
            this.$notify('error', 'Слишком много попыток входа. Попробуйте позже', 5000);
            break;
          default:
            this.$notify('error', `Ошибка ${status}: ${message || 'Неизвестная ошибка'}`, 5000);
        }
      } else if (error.request) {
        this.$notify('error', 'Сервер не отвечает. Проверьте подключение к интернету', 5000);
      } else {
        this.$notify('error', error.message || 'Ошибка при входе в систему', 5000);
      }
    } finally {
      this.submiting = false;
    }}}
}
</script>